import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, config} from 'rxjs';
import {ConfigService} from '../../../../shared/services/config.service';
import {UserService} from '../../../../shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentSearchService {
  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) { }

  private get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-document-key',
        'SessionId': this.userService.sessionId
      })
    };
  }

  getLookUps(): Observable<any> {
    return this.http.get<any>(this.configService.config.documentUrl + `/api/DocumentSearch/GetLookUps`, this.httpOptions);
  }

  search(theSearchParameters): Observable<any> {
    return this.http.post<any>(this.configService.config.documentUrl + `/api/DocumentSearch/GetDocumentCardsBySearch`, JSON.stringify(theSearchParameters), this.httpOptions);
  }

}

export class TwoLineTemplate {
  line1: string;
  line2: string;
}

export class ThreeLineTemplate {
  line1: string;
  line2: string;
  line3: string;
}

export class DetailLine {
  document: TwoLineTemplate;
  type: string;
  category: string;
  version: TwoLineTemplate;
  codes: ThreeLineTemplate;
  attributes: TwoLineTemplate;
  product: TwoLineTemplate;
  thumbnail: string
}


